import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function RawMaterialIndex() {
    const location = useLocation();
    const navigate = useNavigate();
    
    useEffect(() => {
        navigate("/raw-materials/rambos");
    }, [location, navigate]);

    return <></>;
}
